(function () {
  angular.module("akitabox.main", ["akitabox.main.menu"]);
})();
